import {gsap} from "gsap";


const animationEnter = (container) => {
    // console.log("Projects animation ENTERing");

    // Element à animer
    const body_el = document.body;
    const projects_li = container.querySelectorAll("#projects-list li");
    const scroll_link = container.querySelector("#scrollToContentLink");
    gsap.set(scroll_link, {alpha:0, y:120})
    gsap.set(projects_li, {alpha:0, scale:1})
    gsap.set(container, {alpha:1})

    // Gsap timeline
    const tl = gsap.timeline({
        defaults : {
            duration: 1,
            ease: "power3.out",
        },
    });
    //tl.to("body, #project_image_mask", {backgroundColor:'#000000', duration:5, ease:"power1.out"})
        tl.to(projects_li, {alpha:1, scale:1,  duration:.5,ease: "power1.inout",stagger: { // wrap advanced options in an object
            amount: 0.15,
            from: "center",
            ease: "power2.inOut",
        }})
        .to(scroll_link, {alpha:1, y:0, ease:'back.out'}, '-=.3');


    //pour dev
    tl.timeScale( 1 );
    return tl;
}

export default animationEnter;
